import { render, staticRenderFns } from "./AddLabelPopover.vue?vue&type=template&id=b1b14964&scoped=true&"
import script from "./AddLabelPopover.vue?vue&type=script&lang=js&"
export * from "./AddLabelPopover.vue?vue&type=script&lang=js&"
import style0 from "./AddLabelPopover.vue?vue&type=style&index=0&id=b1b14964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b14964",
  null
  
)

export default component.exports